'use client';

import Link from 'next/link';
import { ReactElement, useCallback } from 'react';
import { useAnalytics } from '../analytics/analytics-provider';

interface BreadcrumbLinkProps {
  href: string;
  children: string;
  className?: string;
  clickText?: string;
}

export const BreadcrumbLink = ({
  children,
  ...props
}: BreadcrumbLinkProps): ReactElement => {
  const analytics = useAnalytics();
  const onClick = useCallback(() => {
    analytics.navigationClickEvent({
      navigationType: 'breadcrumb',
      clickText: children,
      linkType: 'link',
    });
  }, [children, analytics]);

  return (
    <Link {...props} onClick={onClick} data-testid={'breadcrumb-links'}>
      {children}
    </Link>
  );
};
